const mime = {
  'application/msword': {
    extension: 'doc',
    icon: 'file-word'
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    extension: 'docx',
    icon: 'file-word'
  },
  'application/vnd.ms-excel': {
    extension: 'xls',
    icon: 'file-excel'
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    extension: 'xlsx',
    icon: 'file-excel'
  },
  'image/jpeg': {
    extension: 'jpg',
    icon: 'file-image'
  },
  'image/png': {
    extension: 'png',
    icon: 'file-image'
  },
  'application/pdf': {
    extension: 'pdf',
    icon: 'file-pdf'
  },
  'application/vnd.oasis.opendocument.text': {
    extension: 'odt',
    icon: 'file-alt'
  },
  'inode/x-empty': {
    extension: '',
    icon: 'file'
  }
}

export function icon (type) {
  return mime[type] ? mime[type].icon : 'file'
}

export function extension (type) {
  return mime[type] ? mime[type].extension : undefined 
}

export function isMimeTypeAvailable (file) {
  // lastModified, lastModifiedDate, name, size, type, webkitRelativePath
  if (file.name.split('.')[1] === 'xls') {
    return true
  }
  return Object.keys(mime).includes(file.type)
}

export function formatBytes (bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
